module.exports = __webpack_public_path__ + "src/assets/img/07.aa9c428f.png";